'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBem = require('../i-bem/i-bem.react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'image',
    tag: 'img',
    attrs: function attrs(_ref) {
        var url = _ref.url,
            alt = _ref.alt,
            width = _ref.width,
            height = _ref.height;

        return {
            alt: alt,
            width: width,
            height: height,
            onClick: this.props.onClick,
            src: url || 'https://yastatic.net/lego/_/La6qi18Z8LwgnZdsAr1qy1GwCwo.gif'
        };
    }
}, {
    propTypes: {
        url: _propTypes2.default.string,
        alt: _propTypes2.default.string,
        width: _propTypes2.default.number,
        height: _propTypes2.default.number
    }
});